export default __webpack_public_path__ + "img/rule_2-f596be42.png";